import type { ParseKeys } from "i18next";
import { type PropsWithChildren, memo } from "react";

import Sidebar from "@/components/shared/app-navigation/sidebar";

type Props = PropsWithChildren<{
  pageTitle?: ParseKeys;
  defaultCollapsed?: boolean;
}>;

const _MainLayout = ({ children, defaultCollapsed = false }: Props) => {
  return (
    <div className="flex min-h-screen w-full">
      <Sidebar defaultCollapsed={defaultCollapsed} />
      <main className="flex-1 relative w-full h-screen overflow-hidden">
        {children}
      </main>
    </div>
  );
};

export const MainLayout = memo(_MainLayout);
